import styled from 'styled-components'
import Cookies from 'components/Common/Cookies'
import Left from './Left'
import { MainContainer, MainWrapper } from './Common/_styles'
import { useLocalStorage } from 'utils/hooks/useLocalStorage'

const Right = styled.div``
const ForgotPassword = () => {
  const [cookiePolicy] = useLocalStorage('wwl-cookie_policy', 'false')

  return (
    <MainWrapper>
      {cookiePolicy !== 'true' && <Cookies />}
      <MainContainer>
        <Left />
        <Right />
      </MainContainer>
    </MainWrapper>
  )
}

export default ForgotPassword
